import { render, staticRenderFns } from "./ItemDetailComponent.vue?vue&type=template&id=0db99da5&scoped=true"
import script from "./ItemDetailComponent.vue?vue&type=script&lang=js"
export * from "./ItemDetailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db99da5",
  null
  
)

export default component.exports